import { useEffect } from "react";
import { useTraderProvider } from "../../providers/TraderProvider";
import { useAuth } from "../../providers/AuthenticationProvider";
import { Box, Typography } from "@mui/material";

const ShowToken = () => {
	const { tokenMQL4, getMQL4Token } = useTraderProvider();
	const { traderProfile } = useAuth();
	useEffect(() => {
		if (traderProfile == null) return;
		getMQL4Token(traderProfile.uid);
	}, [traderProfile]);

	return (
		<>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<Typography variant="body1" fontSize="12px" marginRight="5px">
					Token:
				</Typography>
				<Typography variant="body1" fontSize="12px">
					{tokenMQL4}
				</Typography>
			</Box>
		</>
	);
};

export default ShowToken;
